type RuntimeConfig = Record<string, string | undefined>;

function getRuntimeConfig(): RuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return (window as Window & { __RUNTIME_CONFIG__?: RuntimeConfig }).__RUNTIME_CONFIG__ ?? {};
}

export function getRuntimeConfigValue(key: keyof ImportMetaEnv | string): string | undefined {
  const runtimeValue = getRuntimeConfig()[key as string];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }

  return (import.meta.env as Record<string, string | undefined>)[key as string];
}
